import { Component, OnInit } from "@angular/core";
import { LoadingService } from "./loading.service";

@Component({
    selector: "app-loading",
    templateUrl: "./loading.component.html",
    styleUrls: ["./loading.component.scss"],
    standalone: false
})
export class LoadingComponent implements OnInit {
  isLoading = false;

  onboardingMessages = [
    "Unlocking your next opportunity...",
    "Let's get you ahead of the day.",
    "Your communication command center is loading.",
    "Preparing your flight plan for success.",
    "Powering up your professional voice.",
    "Time to write smarter, not harder.",
  ];

  productivityMessages = [
    "Saving this now, saving you hours later.",
    "Locking in another productivity win.",
    "That's one less thing to type. Forever.",
    "Filing this away for instant recall.",
    "Organizing your genius...",
    "Every shortcut saved is a future minute earned.",
  ];

  strategicMessages = [
    "Calibrating your message for maximum impact.",
    "Crafting your authentic voice...",
    "Ensuring every word drives results.",
    "From a good message to an unforgettable one.",
    "Polishing your prose to perfection.",
    "This is where clarity meets confidence.",
  ];

  analyticsMessages = [
    "Quantifying your communication impact...",
    "Calculating the hours you've reclaimed this month.",
    "Revealing the story your data tells...",
    "Translating your activity into actionable insights.",
    "Proving the ROI of effective communication.",
  ];

  aiMessages = [
    "Engaging our AI to refine your message.",
    "Your personal writing assistant is on the job.",
    "Analyzing context and improving clarity...",
    "Generating a post that will stop the scroll.",
    "Augmenting your expertise with our intelligence.",
  ];

  private readonly loadingMessages = [
    "Signing in...",
    "Redirecting to RolePlay...",
    // "Taking flight...",
    // "Unlocking your next opportunity...",
    // "Your communication command center is loading.",
    // "Calibrating your message for maximum impact.",
    // "Locking in another productivity win.",
    // "Powering up your professional voice.",
    // "Organizing your genius...",
    // "Ensuring every word drives results.",
    // "That's one less thing to type. Forever.",
    // "From a good message to an unforgettable one.",
    // "Let's get you ahead of the day.",
    // "Proving the ROI of effective communication.",
    // "Preparing your flight plan for success.",
    // "This is where clarity meets confidence.",
    // "Polishing your messages...",
    // "Quantifying your communication impact...",
    // "Augmenting your expertise with our intelligence.",
  ];

  currentMessage: string | null = null;

  private intervalId?: number;

  constructor(private loadingService: LoadingService) {}

  ngOnInit(): void {
    this.currentMessage = this.loadingMessages[Math.floor(Math.random() * this.loadingMessages.length)];
    this.loadingService.loading$.subscribe((isLoading) => {
      this.isLoading = isLoading;
      if (isLoading) {
        this.currentMessage = this.loadingMessages[Math.floor(Math.random() * this.loadingMessages.length)];
        this.intervalId = window.setInterval(() => {
          const randomIndex = Math.floor(Math.random() * this.loadingMessages.length);
          this.currentMessage = null;
          setTimeout(() => {
            this.currentMessage = this.loadingMessages[randomIndex];
          }, 100);
        }, 2900);
      } else {
        if (this.intervalId) {
          clearInterval(this.intervalId);
        }
      }
    });
  }
}
